<template>
  <div class="home" :class="{'filterBlur':verificationDialogVisible}">
    <!-- 版本信息 -->
    <!-- <div class="p-a _infoFilled" @click="handleVerInfoClick">
       <svg-icon icon-class="ver_info" class-name="ver_info_icon" />
      <span>
        版本信息
      </span>
    </div> -->
    <img :src="HospitalLogo" class="banner" v-if="HospitalLogo" />
    <img
      v-else
      src="data:image/png;base64,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"
      class="banner"
    />
    <div class="user_card">
      <div class="card_top" v-if="homeInfo.REPORT">
        <svg-icon
          icon-class="girl"
          v-if="homeInfo.REPORT[0].tcPtGender == '女'"
          class-name="photo"
        />
        <svg-icon icon-class="boy" class-name="photo" v-else />
        <div>
          <div class="user_info" v-if="homeInfo.REPORT">
            <span>{{ homeInfo.REPORT[0].tcPtName }}</span>
            <span>{{ homeInfo.REPORT[0].tcPtGender }}</span>
            <span>{{ homeInfo.REPORT[0].tcPtAge }}</span>
          </div>
          <div class="sqNumber" v-if="homeInfo.REPORT">
            <span>申请单号</span>
            <span>{{ homeInfo.REPORT[0].tcStAppno }}</span>
          </div>
        </div>
      </div>
      <div class="card_bottom" v-if="homeInfo.REPORT">
        <div class="time">
          <span>检查时间</span>
          <span>{{
            moment(homeInfo.REPORT[0].tcStChkTime).format("YYYY-MM-DD")
          }}</span>
        </div>
        <div class="type">
          <span>检查类型</span>
          <span>{{ homeInfo.REPORT[0].tcStType }}</span>
        </div>
        <div class="xiangmu">
          <span>检查项目</span>
          <span>{{ homeInfo.REPORT[0].tcStItemName }}</span>
        </div>
        <div class="buwei">
          <span>检查部位</span>
          <span>{{ homeInfo.REPORT[0].tcStBody }}</span>
        </div>
      </div>
      <div class="divider_wrapper">
        <el-divider class="self_divider" />
      </div>
      <!-- 分享 -->
      <div class="card_share" @click="handleDrawer">
        <svg-icon icon-class="share" class-name="share-icon" />
        <span> 分享检查 </span>
      </div>
    </div>
    <div class="icon_wrap">
      <div class="icon_content" @click="imageTextLink()" v-if="handlePermission('图文报告')">
        <svg-icon icon-class="tuwen" class-name="icon" />
        <span>图文报告</span>
      </div>
      <div class="icon_content" @click="jiaopianLink()"  v-if="handlePermission('电子胶片')">
        <svg-icon icon-class="jiaopian" class-name="icon" />
        <span>电子胶片</span>
      </div>
      <div class="icon_content" @click="yingxiangLink()"  v-if="handlePermission('影像浏览')">
        <svg-icon icon-class="yingxiang" class-name="icon" />
        <span>影像浏览</span>
      </div>
      <div class="icon_content" @click="historyLink()"  v-if="handlePermission('历史检查')">
        <svg-icon icon-class="check" class-name="icon" />
        <span>历史检查</span>
      </div>
    </div>
    <div class="yingxiang_wrap">
      <div class="ying_title">
        <svg-icon icon-class="title_bg" class-name="title-icon" />
        <span>影像所见</span>
      </div>
      <div :class="[showTotal ? 'total-introduce' : 'detailed-introduce_']" v-if="homeInfo.REPORT && homeInfo.REPORT[0].reportStat == 'RA'">
        <div
          class="intro-content"
          v-if="homeInfo.REPORT"
          :title="homeInfo.REPORT[0].tcRpFindings"
          ref="desc"
        >
          <span class="merchant-desc">
            {{ homeInfo.REPORT[0].tcRpFindings }}
          </span>
        </div>
        <svg-icon
          @click="showTotalIntro(0)"
          v-if="exchangeButton"
          icon-class="down"
          class-name="down"
        />
        <svg-icon
          @click="showTotalIntro(0)"
          v-if="!exchangeButton"
          icon-class="up"
          class-name="up"
        />
      </div>
    </div>
    <div class="zhenduan_wrap">
      <div class="zhenduan_title">
        <svg-icon icon-class="title_bg" class-name="title-icon" />
        <span>诊断结论</span>
      </div>
      <div :class="[showTotal1 ? 'total-introduce' : 'detailed-introduce_']" v-if="homeInfo.REPORT && homeInfo.REPORT[0].reportStat == 'RA'">
        <div
          class="intro-content"
          v-if="homeInfo.REPORT"
          :title="homeInfo.REPORT[0].tcRpInspectCon"
          ref="desc"
        >
          <span class="merchant-desc">
            {{ homeInfo.REPORT[0].tcRpInspectCon }}
          </span>
        </div>
        <svg-icon
          @click="showTotalIntro(1)"
          v-if="exchangeButton1"
          icon-class="down"
          class-name="down"
        />
        <svg-icon
          @click="showTotalIntro(1)"
          v-if="!exchangeButton1"
          icon-class="up"
          class-name="up"
        />
      </div>
    </div>
  </div>
  <el-drawer v-model="drawer" :direction="'btt'">
    <template #header>
      <div class="drawer_title">
        <span class="back" v-if="flag" @click="flag = !flag">
          <svg-icon icon-class="back2" class-name="back2-icon" />
          返回
        </span>
        分享检查
      </div>
    </template>
    <template #default v-if="!flag">
      <div class="_title">
        <span> 分享时效 </span>
      </div>
      <div class="drawer__body_content">
        <div
          class="_item"
          :class="{ _ac: item.selected }"
          v-for="(item, index) in timeOptions"
          :key="index"
          @click="handleClick(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="_btn" @click="handleNext">下一步</div>
    </template>
    <template #default v-else>
      <div class="_remarks">
        您可以复制链接地址，粘贴至浏览器/微信，进行分享查看
      </div>
      <div class="_user_info">
        <div class="_t">
          {{ homeInfo && homeInfo.REPORT[0].tcPtName }} 的
          {{ homeInfo && homeInfo.REPORT[0].tcStType }} 检查
        </div>
        <div class="_c">
          <span id="clipboard">{{ shareInfo.ruleUrl }}</span>
          <span>链接有效期至: {{ shareInfo.finalTime }}</span>
        </div>
      </div>

      <div
        class="_btn"
        id="clipboardbtn"
        data-clipboard-target="#clipboard"
        @click="handleCopy()"
      >
        复制链接
      </div>
    </template>
  </el-drawer>
  <el-dialog
    v-model="centerDialogVisible"
    title="免责声明"
    width="80%"
    center
    :show-close="false"
  >
    <div class="_item">感谢您对电子胶片的使用与信任！</div>
    <div class="_item">
      为了给您提供更加优质、便捷的电子胶片服务，电子胶片升级了相应的服务功能；同时根据最新监管政策的要求，我们更新了《隐私保护指引》《服务协议》，特向您说明如下：
    </div>
    <div class="_item">
     1、为了向您提供医疗/健康管理服务的相关功能，电子胶片会收集、使用必要信息（例如: 姓名、身份证/护照号、手机号、个人健康信息等），包括但不限于向用户发出活动和服务信息等；
    </div>
    <div class="_item">
      2、电子胶片会采取业界先进的安全措施保护您的信息安全，将对用户资料实行保密，保护您的隐私是电子胶片的一项基本政策；
    </div>
    <div class="_item">
      3、未经您同意，电子胶片不会从第三方处获取、共享或向其提供您的影像或健康信息；
    </div>

    <div class="_item">若您同意，请点击“同意”并开始接受我们的服务。</div>
    <template #footer>
      <div class="dialog_footer">
        <div @click="centerDialogVisible = false">不同意</div>
        <div @click="handleCenterDialogVisible">同意</div>
      </div>
      <!-- <span class="dialog-footer">
        <el-button >Cancel</el-button>
        <el-button type="primary" >
          Confirm
        </el-button>
      </span> -->
    </template>
  </el-dialog>
  <!-- 版本信息 -->
  <dialog-ver-info :verInfoDialogVisible="verInfoDialogVisible" ></dialog-ver-info>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex"
import moment from "moment"
import { getNetworkType } from "../utils/index"
import { ElMessageBox, ElMessage } from "element-plus"
import Clipboard from "clipboard"
import dialogVerInfo from './components/dialogVerInfo.vue';

export default {
  name: "Home",
  components: {
    dialogVerInfo
  },
  data() {
     /* 手机号码格式校验 */
		var chekcPhone = (rule, value, callback) => {
      let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!value) {
        return callback(new Error('手机号码不能为空'));
      } else if (!reg.test(value)) {
        return callback(new Error('手机号格式不正确'));
      } else {
        callback()
      }
		};

    return {
      countdown: 0, // 倒计时
      messageRulesValue:'', //手机短信验证码
      verInfoDialogVisible:false, //版本信息弹窗开关
      codesLength:0, // 验证码长度
      captchas: [{ num: "" }, { num: "" }, { num: "" }, { num: "" }], // 验证码
      role: "",
      clipboardDOM: null,
      centerDialogVisible: false,
      flag: true,
      timeOptions: [
        {
          value: 1000 * 60 * 60,
          label: "1小时",
          selected: true
        },
        {
          value: 1000 * 60 * 60 * 6,
          label: "6小时"
        },
        {
          value: 1000 * 60 * 60 * 24,
          label: "一天"
        },
        {
          value: 1000 * 60 * 60 * 24 * 7,
          label: "一周"
        },
        {
          value: 1000 * 60 * 60 * 24 * 30,
          label: "一月"
        },
        {
          value: 0,
          label: "永久"
        }
      ],
      drawer: false,
      // 是否展示所有文本内容
      showTotal: false,
      // 显示展开还是收起
      exchangeButton: true,
      rem: "",
      showTotal1: false,
      exchangeButton1: true,
      currentIndex: 0 ,// 当前打开哪个文本
      loginVerRules:'1'
    }
  },
  computed: {
    ...mapGetters(["homeInfo","buttonCfg", "HospitalLogo", "shareInfo","verificationDialogVisible","patientPhone"]),
    patientPhoneEncode(){
      function patientPhoneEncode(phoneNumber){

        if (phoneNumber == null) {
            return phoneNumber; // 如果号码为空或长度不足，直接返回原号码
        }
        // 假设手机号码是11位，例如中国的手机号码
        // 如果手机号码长度不同，可以相应地调整索引
        let prefix = phoneNumber.substring(0, 3); // 前三位
        let suffix = phoneNumber.substring(7); // 后四位（包括可能的"-"或空格等）
        let obfuscated = prefix + "****" + suffix; // 隐藏中间四位
        return obfuscated;
      }
      return patientPhoneEncode(this.patientPhone)
    }
  },
  async created() {
    // 获取 buttonCfg 信息
    await this.$store.dispatch("getDicByFieldName",{
      fieldName:'buttonCfg'
    })
    // 请求数据 
    const homeInfo = await this.$store.dispatch("getHomeInfo")
    if(!homeInfo || homeInfo.result.REPORT.length === 0)return ;
    // 需求 13056 
    // 来源 郑州颐和医院 
    // 描述 当患者报告未审核时提醒报告未审核需要耐心等待
    if( homeInfo.result.REPORT[0].reportStat != 'RA' ){
      ElMessage({
        message: "当前报告未出，请稍后再尝试扫码查看",
        type: "warning",
        duration:5000
      })
    }
    const { verificationOnce } = this.$store.getters
    if(verificationOnce){
        return 
    } 
    // 获取医院配置
    this.$store
      .dispatch("getDispConfig")
      .then((res) => {
        const {loginVerRules} =  res.result
        const role = {
          '1':'请输入当前患者申请单号后四位',
          '2':'请输入当前患者手机号后四位',
          '3':'请输入当前患者身份证号后四位',
          '4':'请输入当前患者手机号及验证码',
          '5':'请输入当前患者身份证号或手机号后四位',
        }
        this.role = role[loginVerRules]
        this.loginVerRules = loginVerRules

        // 短信验证码进入
        if(loginVerRules == '4'){
          // 获取手机号
          this.$store.dispatch('getPatientPhone')

        }
        // 更新验证规则的弹窗
        this.$store.dispatch("verificationDialogVisible",!!loginVerRules)
      })
      .catch(() => {})
    // 获取手机号
  },
  methods: {
    moment,
    handlePermission(name){
      let ok = false;
      if(this.buttonCfg){
        if(this.buttonCfg.length > 0){
          for(let i =0;i < this.buttonCfg.length; i++){
            if(this.buttonCfg[i].name == name){
              ok = true;
              break
            }
          }
        }else{
          ok = true
        }
      }else{
        ok = true
      }
      return ok
    },
    handleVerInfoClick(){
      this.$store.dispatch('getProjectVersion').then(()=>{
        this.verInfoDialogVisible = true;
      })
    },
    showTotalIntro(index) {
      this.currentIndex = index
      if (index === 0) {
        this.showTotal = !this.showTotal
        this.exchangeButton = !this.exchangeButton
      } else {
        this.showTotal1 = !this.showTotal1
        this.exchangeButton1 = !this.exchangeButton1
      }
    },
    getRem() {
      const defaultRem = 16
      const winWidth = window.innerWidth
      const rem = (winWidth / 375) * defaultRem
      return rem
    },
    imageTextLink() {
      var params = {}
      if (this.homeInfo && this.homeInfo.REPORT && this.homeInfo.REPORT[0]) {
        params = {
          patientid: this.homeInfo.REPORT[0].tcPtDispNo,
          studyid: this.homeInfo.REPORT[0].tcStGrpNo,
          hospcode: this.homeInfo.REPORT[0].tcHospCode,
          hospdomain: this.homeInfo.REPORT[0].tcHospDomain,
          tcStType: this.homeInfo.REPORT[0].tcStType,
          checkTime: this.homeInfo.REPORT[0].tcStChkTime
        }
      }
      this.$router.push({
        path: "/imageAndText",
        query: params
      })
    },
    jiaopianLink() {
      var params = {}
      if (this.homeInfo && this.homeInfo.REPORT && this.homeInfo.REPORT[0]) {
        params = {
          patientid: this.homeInfo.REPORT[0].tcPtDispNo,
          hospcode: this.homeInfo.REPORT[0].tcHospCode,
          studyid: this.homeInfo.REPORT[0].tcStGrpNo,
          hospdomain: this.homeInfo.REPORT[0].tcHospDomain,
          checkTime: this.homeInfo.REPORT[0].tcStChkTime
        }
      }
      this.$router.push({
        path: "/electronicFilm",
        query: params
      })
    },
    yingxiangLink() {
      var params = {}
      if (this.homeInfo && this.homeInfo.REPORT && this.homeInfo.REPORT[0]) {
        params = {
          patientid: this.homeInfo.REPORT[0].tcPtDispNo,
          hospcode: this.homeInfo.REPORT[0].tcHospCode,
          studyid: this.homeInfo.REPORT[0].tcStGrpNo,
          hospdomain: this.homeInfo.REPORT[0].tcHospDomain,
          checkTime: this.homeInfo.REPORT[0].tcStChkTime,
          tcStType: this.homeInfo.REPORT[0].tcStType,
          enterFlag: "enterFlag"
        }
      }
      if (["wifi"].indexOf(getNetworkType()) === -1) {
        ElMessageBox.confirm(
          "下载影像需要流量较大，是否继续下载？",
          "温馨提示",
          {
            confirmButtonText: "继续下载",
            cancelButtonText: "取消",
            type: "info",
            center: true,
            showClose: false
          }
        )
          .then(() => {
            this.$router.push({
              path: "/imageBrowsing",
              query: params
            })
          })
          .catch(() => {})
      } else {
        this.$router.push({
          path: "/imageBrowsing",
          query: params
        })
      }
    },
    historyLink() {
      var params = {}
      if (this.homeInfo && this.homeInfo.REPORT && this.homeInfo.REPORT[0]) {
        params = {
          patientid: this.homeInfo.REPORT[0].tcPtDispNo
        }
      }
      this.$router.push({
        path: "/historyCheck",
        query: params
      })
    },
    handleClick(item) {
      if (item.selected) return
      this.resettimeOptions()
      item.selected = true
    },
    handleCopy() {
      let _this = this
      this.clipboardDOM.on("success", function (e) {
        //复制成功执行的回调，可选
        ElMessage({
          message: "分享链接复制成功",
          type: "success"
        })
        if (_this.clipboardDOM) {
          _this.clipboardDOM.destroy()
          _this.drawer = false
          e.clearSelection()
        }
      })
      this.clipboardDOM.on("error", function (e) {
        //复制失败执行的回调，可选
        ElMessage({
          message: "分享链接复制失败",
          type: "error"
        })
      })
    },
    handleDrawer() {
      // 声明
      this.centerDialogVisible = true
    },
    handleCenterDialogVisible() {
      this.centerDialogVisible = false
      this.drawer = true
      this.flag = false
      // 重置时间选项
      this.resettimeOptions()
      this.timeOptions[0].selected = true
    },
    /** @description 时间选项重置*/
    resettimeOptions() {
      this.timeOptions.forEach((element) => {
        element.selected = false
      })
    },
    handleNext() {
      this.flag = !this.flag
      this.$store
        .dispatch("getShareInfo", {
          TC_HOSP_NAME: this.homeInfo.REPORT[0].tcHospDomain,
          PARAM_NAME: "webpacs分享"
        })
        .then((result) => {
          let time = 0
          for (let i = 0; i < this.timeOptions.length; i++) {
            if (this.timeOptions[i].selected) {
              time = this.timeOptions[i].value
            }
          }
          this.$store.dispatch("getQRcodeCreate", {
            itemValue: result,
            tcQrcodeFinalTime: time
          })
        })
    },
  },
  watch: {
    flag(newVal, oldVal) {
      if (newVal) {
        let _this = this
        setTimeout(() => {
          var btn = document.getElementById("clipboardbtn")
          _this.clipboardDOM = new Clipboard(btn) //实例化
        }, 300)
        //从属性里复制
      }
    },
    messageRulesValue(newVal, oldVal) {
      let arr = [];
      for(let i= 0; i< newVal.length; i++){
        arr.push({
          num:newVal[i]
        })
      }
      this.captchas = arr
      this.codesLength = this.captchas.length
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss" scope>
@import "../style/theme.scss";
@import "../style/home.scss";
._infoFilled{
    background-color: rgba(255, 255, 255, 0.6);
    padding: 4px 8px;
    border-radius: 20px 0 0 20px;
    right: 0;
    top: 8px;
   font-size: 12px;
}
.card_share {
  font-size: 14px;
  font-weight: 500;
  color: #10a38b;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}
.share-icon {
  width: 20px !important;
  height: 20px !important;
}
.back2-icon {
  width: 16px !important;
  height: 16px !important;
}
.drawer_title {
  text-align: center;
  position: relative;
  height: 47px;
  line-height: 47px;
  font-size: 16px;
  font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.72);
  .back {
    position: absolute;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.54);
    left: 0;
    top: 50%;
    margin-top: -24px;
  }
  .txt {
  }
}
.el-drawer {
  height: 46% !important;
}
.el-drawer__header {
  padding: 0 16px;
  margin-bottom: 0;
}
.el-drawer__body {
  padding: 0 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  ._title {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.72);
  }
  .drawer__body_content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-evenly;
    flex: 1;
    ._item {
      width: 100px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      background: #ebfdfb;
      border-radius: 8px 8px 8px 8px;
      font-size: 14px;
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.72);
      border: 1px solid #ebfdfb;
    }
    ._ac {
      color: #10a38b;
      border: 1px solid #10a38b;
    }
  }
  ._btn {
    background: #10a38b;
    height: 46px;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    line-height: 46px;
    border-radius: 23px 23px 23px 23px;
  }

  ._remarks {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.72);
    line-height: 24px;
    padding: 16px 0;
  }
  ._user_info {
    flex: 1;
    display: flex;
    flex-direction: column;
    ._t {
      padding-left: 24px;
      height: 43px;
      line-height: 43px;
      background: #10a38b;
      border-radius: 16px 16px 0px 0px;
      font-size: 16px;
      color: #ffffff;
    }
    ._c {
      flex: 1;
      padding: 16px 24px;
      border-radius: 0px 0px 16px 16px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.72);
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.06);
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-bottom: 24px;
      line-height: 20px;
      span:nth-child(1) {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

.el-dialog {
  border-radius: 8px 8px 8px 8px;
  overflow: hidden;
}
.el-dialog__header {
  padding: 0;
  padding-bottom: 0;
  margin-right: 0;
  .el-dialog__title {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.72);
    line-height: 40px;
  }
}
.el-dialog__body {
  padding: 0 20px !important;
  ._item {
    padding-bottom: 10px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.72);
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    line-height: 22px;
  }
}
.el-dialog__footer {
  padding: 0;
  padding-top: 0;
}
.dialog_footer {
  font-size: 16px;
  height: 47px;
  line-height: 47px;
  text-align: center;
  display: flex;
  div:nth-child(1) {
    color: rgba(0, 0, 0, 0.72);
    flex: 1;
    border-top: 1px solid #707070;
  }
  div:nth-child(2) {
    color: #fff;
    flex: 1;
    background: #10a38b;
  }
}

.verification_dialog {
  height: 100%;
  width: 100% !important;
  margin: 0;
  background-color: rgba(240, 241, 242, 0.8);
  padding-top: 85px;
  border-radius: 0;
  // backdrop-filter: blur(6px);
  // backdrop-filter:blur(50px);
  // filter: blur(2px);
  ._title {
    color: #343a40;
    font-size: 20px;
    text-align: center;
    font-weight: 600;
  }
  ._content {
    flex: 1;
    margin-top: 85px;
    ._content_title {
      color: #343a40;
      font-weight: 600;
      font-size: 16px;
      text-align: left;
    }
    .fill-message {
      display: flex;
      justify-content: space-between;
      margin-top: 44px;
      div {
        // border: 1px solid #10a38b;
        text-align: center;
        line-height: 64px;
        font-size: 24px;
        font-weight: 600;

        // width: 64px;
        // height: 64px;
        input{
          border: 0;
          display: block;
          // flex: 1;
          width: 64px;
          height: 64px;
          background: #ffffff;
          outline: none;
          padding: 0;
          // font-size: 20px;
          font-weight: bold;
          // background: rgba(242, 244, 248, 1);
          border-radius: 0.22rem;
          text-align: center;
          transition: all ease 0.6s;
          border-radius: 12px 12px 12px 12px;
          border: 1px solid #333;
          // border: 1px solid #10a38b;
          &:last-child {
            margin-right: 0;
          }
          &:focus {
            border-color: #333;
          }
        }
        .ac{
          border: 1px solid #10a38b !important;
        }
      }
    }
  }
  ._footer {
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background: #86909c;
    border-radius: 23px 23px 23px 23px;
    margin-bottom: 56px;
  }
  ._footer_ac{
    background:#10A38B
  }

  .el-dialog__body {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.phone_num{
  margin-top: 50px;
  height: 46px;
  line-height: 46px;
  border-radius: 0.32rem 0.32rem 0.32rem 0.32rem;
  background: #FFFFFF;
  color: #a8abb2;
  padding-left: 10px;
}

.validate_btn_wrapper{
  margin-top: 20px;
  display: flex;
  align-items: center;
  height: 46px;
  border-radius: 12px 12px 12px 12px;
  background: #FFFFFF;
  overflow:hidden;
  .el-input{
    height: 46px;
    width: 70%;
    .el-input__wrapper{
      box-shadow: none;
    }
  }
}
.validate_txt {

  font-size: 14px;
  width: 30%;
  text-align: center;
  line-height: 46px;
  .el-button {
    color: #3491FA;
  }
  .el-button.is-link:hover {
    color: #3491FA;
  }
  .el-button.is-link.is-disabled{
    color:#a8abb2
  }
}
.validate_border{
   height: 30%;
   border: 1px solid #C9CDD4;
}
.filterBlur{
  filter: blur(2px);

}

._zhuShi{
  font-size: 12px;
  padding: 0 0 10px 10px;
  color: #777;
}
</style>
